export default {
	_body                : document.querySelector('body'),
	_activeMenuBodyClass : 'menu-active',
	_toggles             : null,
	init() {
		this._body.classList.remove(this._activeMenuBodyClass);
		this._toggles = document.querySelectorAll('[data-toggle]');
		if (!this._toggles.length) {
			return;
		}
		Array.prototype.forEach.call(this._toggles, toggle => {
			const target = toggle.getAttribute('data-toggle');
			if (target === 'menu') {
				const targetElement = document.querySelector(`[data-toggle-target='${target}']`);
				let activeClass     = toggle.getAttribute('data-toggle-class');
				if (!activeClass) {
					activeClass = 'active';
				}
				toggle.classList.remove(activeClass);
				if (targetElement) { targetElement.classList.remove(activeClass); }
			}
		});
		Array.prototype.forEach.call(this._toggles, toggle => {
			toggle.addEventListener('click', this._toggle.bind(this, toggle));
		});
	},
	_toggle(toggle) {
		const closeOthers = toggle.getAttribute('data-close-others') === 'true';
		const targets     = document.querySelectorAll(`[data-toggle-target='${toggle.getAttribute('data-toggle')}']`);
		if (!targets) {
			return;
		}
		let toggleClass = toggle.getAttribute('data-toggle-class');
		if (!toggleClass) {
			toggleClass = 'active';
		}
		if (toggle.classList.contains(toggleClass)) {
			toggle.classList.remove(toggleClass);
		} else {			
			toggle.classList.add(toggleClass);
		}
		for (const target of targets) {
			let targetClass = target.getAttribute('data-target-class');
			if (!targetClass) {
				targetClass = toggleClass;
			}
			if (closeOthers) {
				this._hideAll();
			}
			if (target.classList.contains(targetClass)) {
				this._hide(toggle, target);
			} else {
				this._show(toggle, target);
			}
		}
	},
	_hideAll() {
		Array.prototype.forEach.call(this._toggles, toggle => {
			const target = document.querySelector(`[data-toggle-target='${toggle.getAttribute('data-toggle')}']`);
			if (target) {
				this._hide(toggle, target);
			}
		});
	},
	_show(toggle, target) {
		let toggleClass = toggle.getAttribute('data-toggle-class');
		let targetClass = target.getAttribute('data-target-class');
		if (!toggleClass) {
			toggleClass = 'active';
		}
		if (!targetClass) {
			targetClass = toggleClass;
		}
		if (toggle.getAttribute('data-toggle') === 'menu') {
			this._body.classList.add(this._activeMenuBodyClass);
		}
		//toggle.classList.add(toggleClass);
		target.classList.add(targetClass || toggleClass);
	},
	_hide(toggle, target) {
		let toggleClass = toggle.getAttribute('data-toggle-class');
		let targetClass = target.getAttribute('data-target-class');
		if (!toggleClass) {
			toggleClass = 'active';
		}
		if (!targetClass) {
			targetClass = toggleClass;
		}
		if (toggle.getAttribute('data-toggle') === 'menu' &&
			this._body.classList.contains(this._activeMenuBodyClass)) {
			this._body.classList.remove(this._activeMenuBodyClass);
		}
		//toggle.classList.remove(toggleClass);
		target.classList.remove(targetClass || toggleClass);
	}
};